export default {
  total_orders: {
    title: 'Ordini',
    orders: 'Ordini:',
    sales_volume: 'Volume vendite:',
    delivery_costs: 'Costi di consegna:',
  },
  cash_orders: {
    title: 'Pagamento in contanti/ alla porta',
    orders: 'Ordini:',
    sales_volume: 'Volume vendite:',
    delivery_costs: 'Costi di consegna:',
  },
  online_orders: {
    title: 'Pagamenti online',
    orders: 'Ordini:',
    sales_volume: 'Volume vendite:',
    delivery_costs: 'Costi di consegna:',
  },
  total: 'Totale',
  collected_taxes_list: {
    title: {
      online: 'Pagamento online',
      cash: 'Pagamento in contanti',
    },
    table: {
      products_breakdown: {
        fields: {
          product: 'Prodotto',
          quantity: 'Quantità',
          total: 'Totale',
        },
        labels: {
          total_refunded: 'Rimborsato',
        },
      },
      tax_breakdown: {
        fields: {
          tax_percentage: 'IVA %',
          product_type: 'Tipo',
          netto: 'Netto',
          tax: 'IVA',
          brutto: 'Totale',
        },
        product_types: {
          product: 'Prodotti {{percentage}}%',
          order_method_fee: 'Spese di consegna {{percentage}}%',
          customer_service_fee: 'Supplemento online',
        },
      },
    },
  },
};
